import React, { Component, useState } from 'react';
import styles from './systemSettings.module.scss';

const SystemSettings: React.FC = (): JSX.Element => {
  return (
    <div className={styles.pageWrapper}>
      <div className={styles.title}>Systems Settings</div>
    </div>
  );
};
export default SystemSettings;
